import { formatPrice, parsePrice } from 'helpers';
import { NumberInput } from 'libs/ui';
import { NumberInputProps } from 'libs/ui/NumberInput/types';

import { FieldType } from '../types';
import { useField } from '../useField';

export interface TextFieldProps
  extends FieldType,
    Omit<NumberInputProps, 'name' | 'onChange' | 'onChangeText' | 'value'> {}

/**
 * Price field.
 */
export const PriceField = ({
  name,
  allowSubmit,
  readOnly,
  parse = parsePrice,
  format = formatPrice,
  ...props
}: TextFieldProps) => {
  const { field, helpers, inputProps } = useField<number | undefined>(name);

  const isError = inputProps.error;
  const { helperText } = inputProps;

  return (
    <NumberInput
      {...props}
      fullWidth
      error={isError}
      format={format}
      helperText={helperText}
      name={name}
      parse={parse}
      readOnly={readOnly || inputProps.readOnly}
      showCopyButton={inputProps.showCopyButton}
      value={field.value}
      onBlur={field.onBlur(name)}
      onChange={() => {
        if (isError) {
          helpers.setError(undefined);
        }
      }}
      onChangeText={(v) => {
        helpers.setValue(v);
      }}
    />
  );
};
